var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NativeReanimated = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _reactNative = require("react-native");
var _checkCppVersion = require("../platform-specific/checkCppVersion");
var _valueUnpacker = require("../valueUnpacker");
var NativeReanimated = exports.NativeReanimated = function() {
    function NativeReanimated() {
        (0, _classCallCheck2.default)(this, NativeReanimated);
        this.native = true;
        this.InnerNativeModule = void 0;
        if (global.__reanimatedModuleProxy === undefined) {
            var ReanimatedModule = _reactNative.NativeModules.ReanimatedModule;
            ReanimatedModule == null ? void 0 : ReanimatedModule.installTurboModule();
        }
        if (global.__reanimatedModuleProxy === undefined) {
            throw new Error("[Reanimated] Native part of Reanimated doesn't seem to be initialized.\nSee https://docs.swmansion.com/react-native-reanimated/docs/guides/troubleshooting#Native-part-of-reanimated-doesnt-seem-to-be-initialized for more details.");
        }
        (0, _checkCppVersion.checkCppVersion)();
        this.InnerNativeModule = global.__reanimatedModuleProxy;
        this.InnerNativeModule.installValueUnpacker((0, _valueUnpacker.getValueUnpackerCode)());
    }
    (0, _createClass2.default)(NativeReanimated, [
        {
            key: "makeShareableClone",
            value: function makeShareableClone(value, shouldPersistRemote) {
                return this.InnerNativeModule.makeShareableClone(value, shouldPersistRemote);
            }
        },
        {
            key: "makeSynchronizedDataHolder",
            value: function makeSynchronizedDataHolder(valueRef) {
                return this.InnerNativeModule.makeSynchronizedDataHolder(valueRef);
            }
        },
        {
            key: "getDataSynchronously",
            value: function getDataSynchronously(ref) {
                return this.InnerNativeModule.getDataSynchronously(ref);
            }
        },
        {
            key: "scheduleOnUI",
            value: function scheduleOnUI(shareable) {
                return this.InnerNativeModule.scheduleOnUI(shareable);
            }
        },
        {
            key: "createWorkletRuntime",
            value: function createWorkletRuntime(name, initializer) {
                return this.InnerNativeModule.createWorkletRuntime(name, initializer);
            }
        },
        {
            key: "registerSensor",
            value: function registerSensor(sensorType, interval, iosReferenceFrame, handler) {
                return this.InnerNativeModule.registerSensor(sensorType, interval, iosReferenceFrame, handler);
            }
        },
        {
            key: "unregisterSensor",
            value: function unregisterSensor(sensorId) {
                return this.InnerNativeModule.unregisterSensor(sensorId);
            }
        },
        {
            key: "registerEventHandler",
            value: function registerEventHandler(eventHandler, eventName, emitterReactTag) {
                return this.InnerNativeModule.registerEventHandler(eventHandler, eventName, emitterReactTag);
            }
        },
        {
            key: "unregisterEventHandler",
            value: function unregisterEventHandler(id) {
                return this.InnerNativeModule.unregisterEventHandler(id);
            }
        },
        {
            key: "getViewProp",
            value: function getViewProp(viewTag, propName, callback) {
                return this.InnerNativeModule.getViewProp(viewTag, propName, callback);
            }
        },
        {
            key: "configureLayoutAnimation",
            value: function configureLayoutAnimation(viewTag, type, sharedTransitionTag, config) {
                this.InnerNativeModule.configureLayoutAnimation(viewTag, type, sharedTransitionTag, config);
            }
        },
        {
            key: "enableLayoutAnimations",
            value: function enableLayoutAnimations(flag) {
                this.InnerNativeModule.enableLayoutAnimations(flag);
            }
        },
        {
            key: "configureProps",
            value: function configureProps(uiProps, nativeProps) {
                this.InnerNativeModule.configureProps(uiProps, nativeProps);
            }
        },
        {
            key: "subscribeForKeyboardEvents",
            value: function subscribeForKeyboardEvents(handler, isStatusBarTranslucent) {
                return this.InnerNativeModule.subscribeForKeyboardEvents(handler, isStatusBarTranslucent);
            }
        },
        {
            key: "unsubscribeFromKeyboardEvents",
            value: function unsubscribeFromKeyboardEvents(listenerId) {
                this.InnerNativeModule.unsubscribeFromKeyboardEvents(listenerId);
            }
        }
    ]);
    return NativeReanimated;
}();
